import React from "react";
import ParametroRating from "./parametroRating/parametroRating";
import SimuladorCreditoEmpreendimentoParametro from "./simuladorCreditoEmpreendimentoParametro/simuladorCreditoEmpreendimentoParametro";
import PropostaEmpreendimentoParametro from "./propostaEmpreendimentoParametro/propostaEmpreendimentoParametro";
import ProvisaoDevedoresDuvidosos from "./provisaoDevedoresDuvidosos/provisaoDevedoresDuvidosos";
import Seguro from "./seguro/seguro";
import MultiplicadorPddIntermediarias from "./multiplicadorPddIntermediarias/multiplicadorPddIntermediarias";
import ParametroCotaFinanciamento from "./parametroCotaFinanciamento/parametroCotaFinanciamento";
import ProjecaoMensal from "./projecaoMensal/projecaoMensal";
import ParametroJurosFinanciamento from "./parametroJurosFinanciamento/parametroJurosFiananciamento";
import OperadorParametrosFaixaBancaria from "./operadorParametrosFaixaBancaria/operadorParametrosFaixaBancaria";
import ParametroCupom from './parametroCupom/parametroCupom';
import { SessionStorageUtils } from "../../../lib/share/utils/sessionStorageUtils";
import ParametroFatorMargemVplAlvo from "./parametroFatorMargemVplAlvo/parametroFatorMargemVplAlvo";
import "./cadastroParametros.css";
import ParametroFlex from "./parametroFlex/parametroFlex";
import DescontoFlex from "./descontoFlex/descontoFlex";
import ParametroProSolutoB from "./parametroProSolutoB/parametroProSolutoB";
import Cluster from "./cluster/cluster";
import ParametroRatingCluster from "./parametroRatingCluster/parametroRatingCluster";
import OperadorParametroFaixaBancariaCluster from "./operadorParametroFaixaBancariaCluster/operadorParametroFaixaBancariaCluster";
import ParametroComissao from "./comissao/comissao";
import ProjecaoMensalFlex from "./projecaoMensalFlex/projecaoMensalFlex";
import ComissaoFlex from "./comissaoFlex/comissaoFlex";
import RegrasExtrasFlex from "./regrasExtrasFlex/regrasExtrasFlex";
import { PermissoesUsuario } from "../../../lib/share/utils/constantes";
import ParametroDiferencaComissao from "./diferencaComissao/diferencaComissao";
import ParametroLimiteComissao from "./limiteComissao/limiteComissao";
import ParametroParcelamentoComissao from "./parcelamentoComissao/parcelamentoComissao";
import ParametroEmpreendimentosExcluidos from "./empreendimentosExcluidos/empreendimentoExcluidos";

interface ParametroModel 
{
    nome: string;
    valor: string;
    componente: JSX.Element;
    permissao?: string;
}

class CadastroParametros extends React.Component<{}, { parametro: string }> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {parametro: 'ParametroRating'};
        this.modificarParametro = this.modificarParametro.bind(this);
    }

    modificarParametro(event: any): void 
    {
        this.setState({ parametro: event.target.value });
    }

    verificarPermissoes(permissao: any) {
        const permissoesAtuais = SessionStorageUtils.getItemsFromSessionStorage("permissoes");
        
        if (permissoesAtuais === null) return false;
        
        const permissaoUpper = permissao.toUpperCase();
        const permissoesUpper = permissoesAtuais.map((p: string) => p.toUpperCase());
        
        return permissoesUpper.includes(permissaoUpper);
    }

    obterOpcoesComPermissao = (): ParametroModel[] => {
        return this.opcoesParametros.filter(opcao => {
            if (!opcao.permissao) {
                return true;
            }
            return this.verificarPermissoes(opcao.permissao);
        });
    }

    possuiPermissaoParaAlgumParametro(): boolean {
        return this.obterOpcoesComPermissao().some(opcao => {
            if (!opcao.permissao) {
                return true;
            }
            return this.verificarPermissoes(opcao.permissao);
        });
    }

    opcoesParametros: ParametroModel[] = 
    [
        {
            nome: "% Desconto Flex",
            valor: "DescontoFlex",
            componente: <DescontoFlex />,
            permissao: PermissoesUsuario.EditarDescontoFlex
        },
        {
            nome: "Multiplicador PDD Intermediárias",
            valor: "MultiplicadorPddIntermediarias",
            componente: <MultiplicadorPddIntermediarias />,
            permissao: PermissoesUsuario.EditarParametrosPDDIntermediaria
        },
        {
            nome: "Operador Parâmetros Faixa Bancária",
            valor: "OperadorParmetrosFaixaBancária",
            componente: <OperadorParametrosFaixaBancaria />,
            permissao: PermissoesUsuario.EditarParametrosBancario
        },
        {
            nome: "Parâmetro Cota de Financiamento",
            valor: "ParametroCotaFinanciamento",
            componente: <ParametroCotaFinanciamento />,
            permissao: PermissoesUsuario.EditarParametrosCotaFinanciamento
        },
        {
            nome: "Parâmetro Cupom",
            valor: "ParametroCupom",
            componente: <ParametroCupom />,
            permissao: PermissoesUsuario.EditarParametroCupom
        },
        {
            nome: "Parâmetro Fator Margem Alvo e VPL Alvo",
            valor: "ParametroFatorMargemVplAlvo",
            componente: <ParametroFatorMargemVplAlvo />,
            permissao: PermissoesUsuario.EditarParametroFatorMargemVplAlvo
        },
        {
            nome: "Parâmetro Flex",
            valor: "ParametroFlex",
            componente: <ParametroFlex />,
            permissao: PermissoesUsuario.EditarParametroFlex
        },
        {
            nome: "Parâmetro Juros de Financiamento",
            valor: "ParametroJurosFinanciamento",
            componente: <ParametroJurosFinanciamento />,
            permissao: PermissoesUsuario.EditarParametrosJurosFinanciamento
        },
        {
            nome: "Regras Extras Flex",
            valor: "RegrasExtrasFlex",
            componente: <RegrasExtrasFlex />,
            permissao: PermissoesUsuario.EditarRegrasExtrasFlex
        },
        {
            nome: "Parâmetro PDD Gerador",
            valor: "ProvisaoDevedoresDuvidosos",
            componente: <ProvisaoDevedoresDuvidosos />,
            permissao: PermissoesUsuario.EditarParametrosPDDGerador
        },
        {
            nome: "Parâmetro Projeção Mensal",
            valor: "ProjecaoMensal",
            componente: <ProjecaoMensal />,
            permissao: PermissoesUsuario.EditarParametrosProjecaoMensal
        },
        {
            nome: "Projeção Mensal Flex",
            valor: "ProjecaoMensalFlex",
            componente: <ProjecaoMensalFlex />,
            permissao: PermissoesUsuario.EditarProjecaoMensalFlex
        },
        {
            nome: "Parâmetro Proposta",
            valor: "PropostaEmpreendimentoParametro",
            componente: <PropostaEmpreendimentoParametro />,
            permissao: PermissoesUsuario.EditarParametrosProposta
        }, 
        {
            nome: "Parâmetro Rating",
            valor: "ParametroRating",
            componente: <ParametroRating />,
            permissao: PermissoesUsuario.EditarParametrosRating
        },
        {
            nome: "Parâmetro Seguro",
            valor: "Seguro",
            componente: <Seguro />,
            permissao: PermissoesUsuario.EditarParametrosSeguro
        },
        {
            nome: "Parâmetro Simulador Crédito",
            valor: "SimuladorCreditoEmpreendimentoParametro",
            componente: <SimuladorCreditoEmpreendimentoParametro />,
            permissao: PermissoesUsuario.EditarParametrosSimululacaoCredito
        },
        {
            nome: "Parâmetro Pró-Soluto B",
            valor: "ParametroProSolutoB",
            componente: <ParametroProSolutoB />,
            permissao: PermissoesUsuario.EditarParametroProSolutoB
        },
        {
            nome: "Parâmetro Cluster Unitário",
            valor: "Cluster",
            componente: <Cluster/>,
            permissao: PermissoesUsuario.EditarParametroCluster
        },
        {
            nome: "Parâmetro Rating Cluster",
            valor: "ParametroRatingCluster",
            componente: <ParametroRatingCluster/>,
            permissao: PermissoesUsuario.EditarParametrosRatingCluster
        },
        {
            nome: "Parametros Cluster Faixa Bancaria",
            valor: "OperadorParametroFaixaBancáriaCluster",
            componente: <OperadorParametroFaixaBancariaCluster />,
            permissao: PermissoesUsuario.EditarParametrosBancario
        },
        {
            nome: "Comissão",
            valor: "ParametroComissao",
            componente: <ParametroComissao />,
            permissao: PermissoesUsuario.EditarComissao
        },
        {
            nome: "Comissão Flex",
            valor: "ComissaoFlex",
            componente: <ComissaoFlex />,
            permissao: PermissoesUsuario.EditarComissaoFlex
        },
        {
            nome: "Diferença Comissão",
            valor: "ParametroDiferencaComissao",
            componente: <ParametroDiferencaComissao />,
            permissao: PermissoesUsuario.EditarDiferencaComissao
        },
        {
            nome: "Limite Comissão",
            valor: "ParametroLimiteComissao",
            componente: <ParametroLimiteComissao />,
            permissao: PermissoesUsuario.EditarLimiteComissao
        },
        {
            nome: "Parcelamento Comissão",
            valor: "ParametroParcelamentoComissao",
            componente: <ParametroParcelamentoComissao />,
            permissao: PermissoesUsuario.EditarParcelamentoComissao
        },
        {
            nome: "Empreendimentos Excluídos",
            valor: "ParametroEmpreendimentosExcluidos",
            componente: <ParametroEmpreendimentosExcluidos />,
            permissao: PermissoesUsuario.EditarEmpreendimentosExcluidos
        }
    ];

    selecionarComponente = (parametro: string): JSX.Element | undefined => 
    {
        return this.opcoesParametros.find((param: ParametroModel) => 
        {
            return parametro === param.valor;
        })?.componente;
    }

    render() 
    {
        if (!this.possuiPermissaoParaAlgumParametro()) {
            return (
                <section className="card-principal">
                    <div className="acesso-negado">
                        <h1 className="titulo">Acesso Negado</h1>
                        <p className="mensagem-acesso-negado">
                            Você não possui permissão para acessar a funcionalidade de Cadastro de Parâmetros.
                        </p>
                    </div>
                </section>
            );
        }

        const opcoesComPermissao = this.obterOpcoesComPermissao();
        
        return (
            <section className="card-principal">
                <h1 className="titulo">Cadastro de parâmetros</h1>
                <label htmlFor="parametros" className="titulo-descricao">Selecione abaixo o parâmetro que deseja cadastrar</label>
                <select value={this.state.parametro} onChange={this.modificarParametro} id="parametros" className="select-parametro">
                    {opcoesComPermissao.map(opcao => (
                        <option value={opcao.valor} key={opcao.valor} className="select-parametro__opcao">{opcao.nome}</option>
                    ))}
                </select>
                {this.selecionarComponente(this.state.parametro)}
            </section>);
    }
}

export default CadastroParametros